module.exports = __webpack_public_path__ + "assets/dog-bowl-pink.89d8d6c3.svg";